import React from "react";
import { FlexContainer } from "../../constants/assets/containers";
import PaginatedReactDropdown from "../../components/Common/PaginatedReactDropdown";
import Input from "sushiweb/InputTypes/Input";
import Button from "sushiweb/Button";
import { isValNull } from "../../utils";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as LifeLineAction from "../../store/actions/LifeLine";
import * as UserActions from "../../store/actions/User";
import LifeLineOrderDetailCard from "../../components/LifeLine/index.js";
import BlankState from "../../components/Common/BlankState";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { getPath } from "../../utils";

const UserFilters = [
  { key: "order_id", label: "Order ID" },
  { key: "driver_id", label: "Driver FE ID" },
  { key: "phone_no", label: "Driver Phone Number" },
];

const LifeLine = (props) => {
  const { getOrderDetails, orderDetails, setStatus, setSideBarCollapsed } =
    props;
  const history = useHistory();
  const params = useParams();
  const location = useLocation();
  const filterType = getPath(params, "filter_type", undefined);
  const filterValue =
    getPath(params, "filter_value", undefined) + location.hash;

  const [initialState, setInitialState] = React.useState({
    filterType: "order_id",
    filterValue: "",
  });

  const handleChange = (key, value) => {
    setInitialState((prevState) => {
      return { ...prevState, [key]: value };
    });
  };

  React.useEffect(() => {
    if (filterType && filterValue) {
      setInitialState({
        filterType: filterType,
        filterValue: filterValue,
      });
      getOrderDetails(filterType, filterValue);
    }
    setSideBarCollapsed(true);
  }, []);

  const handleSubmit = () => {
    if (!initialState.filterValue) {
      if (initialState.filterType === "order_id") {
        setStatus({ type: "error", message: "Please Enter Order Id" });
        return;
      } else if (initialState.filterType === "driver_id") {
        setStatus({ type: "error", message: "Please Enter Driver Id" });
        return;
      } else {
        setStatus({ type: "error", message: "Please Enter Filter Id" });
        return;
      }
    }
    history.push(
      `/lifeline/${initialState.filterType}/${initialState.filterValue}`
    );
  };

  const getInputLabel = (val, options, fromKey, toKey) => {
    const activeEle = options.find((item) => {
      return item[fromKey] === val;
    });
    return !isValNull(activeEle) ? activeEle[toKey] : "";
  };

  return (
    <section>
      <form onSubmit={handleSubmit}>
        <FlexContainer className="mb-20" align="flex-start" justify="center">
          <PaginatedReactDropdown
            options={UserFilters}
            data-testid="FilterTypeDropDown"
            placeholder=""
            value={getInputLabel(
              initialState.filterType,
              UserFilters,
              "key",
              "label"
            )}
            handleChange={handleChange}
            keyToChange="filterType"
            showCross={false}
            id="FilterTypeDropDown"
            width="20%"
            labelKey="label"
            valueKey="key"
          />
          <div
            style={{
              width: "40%",
            }}
          >
            <Input
              value={initialState.filterValue}
              data-testid="orderFiletrInput"
              id="sushi-input"
              onChange={(e) => handleChange("filterValue", e)}
              width={"50%"}
            />
          </div>
          <Button
            data-testid="submitOrderFilterButton"
            className="sushi-btn"
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </FlexContainer>
      </form>

      {orderDetails.map((item) => (
        <LifeLineOrderDetailCard data={item} />
      ))}
      {orderDetails.length === 0 && <BlankState />}
    </section>
  );
};

const mapStateToProps = (state) => {
  const { LifeLine } = state;
  return {
    orderDetails: LifeLine.orderDetails,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getOrderDetails: bindActionCreators(
      LifeLineAction.getLifeLineOrderDetails,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    setSideBarCollapsed: bindActionCreators(
      UserActions.setSideBarCollapsed,
      dispatch
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LifeLine);
